import { GetRolesRoutine, UpdateRoleRoutine, DeleteRoleRoutine } from '~modules/Auth/redux-routines';

export const initialState = {
  data: {},
  error: null,
  isFetching: false,
};

export const rolesReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetRolesRoutine.REQUEST:
    case UpdateRoleRoutine.REQUEST:
    case DeleteRoleRoutine.REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GetRolesRoutine.SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      };
    }
    case GetRolesRoutine.FAILURE:
    case UpdateRoleRoutine.FAILURE:
    case DeleteRoleRoutine.FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };

    default:
      return state;
  }
};
